import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter72.json";
import Head from "next/head";
export default function Chapter_72() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Perennial Mandalan Creed blending tradition, philosophy, and balanced freedom"
        ></meta>
        <meta
          property="og:title"
          content="The Perennial Mandalan Creed: A Balanced Path Between Tradition and Freedom"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Rooted in the Bhagavad Gita, Gospel of Thomas, and Tao Te Ching, the Perennial Mandalan Creed blends Dharma, Karma, Jnana, Bhakti, and Sannyasa. In an age of polarization between rigid traditionalism and radical personal freedom, our doctrine offers a middle way—honoring timeless values while embracing respectful individual rights and spiritual inclusivity."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=72"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=72"
        ></meta>
        <meta
          name="twitter:title"
          content="The Perennial Mandalan Creed: A Balanced Path Between Tradition and Freedom"
        ></meta>
        <meta
          name="twitter:description"
          content="The Perennial Mandalan Creed unites sacred wisdom with modern insight, guiding seekers through today’s ideological divide. Drawing from holy texts and philosophical traditions, it champions simplicity, devotion, and wisdom, while advocating for balance between tradition and personal liberty. Our path invites a harmonious vision of morality, identity, and spiritual growth in a fractured age."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=72" />
      </Head>
      <Common_html BlockData={BlockData} />


    </>
  );
}
